import { useAuthStore } from '../../store';
import UserTable from './UserTable';
import React from 'react';
import SearchFilter from '../../components/ui/filters/SearchFilter';
import PrimaryButton from '../../components/ui/PrimaryButton';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const UserPage = () => {
  const api = '/users';
  const moduleName = 'User';
  const moduleCode = 'USER';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );

  const navigate = useNavigate();

  return (
    <>
      <div className={'page-wrapper'}>
        <div className={'flex p-4 justify-between'}>
          <SearchFilter />
          <PrimaryButton
            icon={<PlusOutlined />}
            onClick={() => navigate('/user/create')}
            label={'Create'}
          />
        </div>
        <UserTable
          api={api}
          moduleName={moduleName}
          userModuleAccess={userModuleAccess}
        />
      </div>
    </>
  );
};

export default UserPage;
